export function detailedStockValidate(detail){
    var result = true;

    result = validateId(detail.id);
    result = validateQuantity(detail.quantity);
    result = validateDamaged(detail.damaged);
    result = validateQuarantine(detail.quarantine);
    result = validateSku(detail.sku);
    
    return result;
}

function validateId(id) {
    return typeof id === 'number'
}

function validateQuantity(quantity) {
    return typeof quantity === 'number'
}

function validateDamaged(damaged) {
    return typeof damaged === 'number'
}

function validateQuarantine(quarantine) {
    return typeof quarantine === 'boolean'
}

function validateSku(sku) {
    if(typeof sku === 'string' && sku.trim() !== '') return true;
    else return false;
}